function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};
window.recentlyViewedIds = [];

/**
 *  @class
 *  @function Quantity
 */
if (!customElements.get('quantity-selector')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.qty');
      this.step = this.input.getAttribute('step');
      this.changeEvent = new Event('change', {
        bubbles: true
      });
      // Create buttons
      this.subtract = this.querySelector('.minus');
      this.add = this.querySelector('.plus');

      // Add functionality to buttons
      this.subtract.addEventListener('click', () => this.change_quantity(-1 * this.step));
      this.add.addEventListener('click', () => this.change_quantity(1 * this.step));

    }
    connectedCallback() {
      this.classList.add('buttons_added');
      this.validateQtyRules();
    }
    change_quantity(change) {
      // Get current value
      let quantity = Number(this.input.value);

      // Ensure quantity is a valid number
      if (isNaN(quantity)) quantity = 1;

      // Check for min & max
      if (this.input.getAttribute('min') > (quantity + change)) {
        return;
      }
      if (this.input.getAttribute('max')) {
        if (this.input.getAttribute('max') < (quantity + change)) {
          return;
        }
      }
      // Change quantity
      quantity += change;

      // Ensure quantity is always a number
      quantity = Math.max(quantity, 1);

      // Output number
      this.input.value = quantity;

      this.input.dispatchEvent(this.changeEvent);

      this.validateQtyRules();
    }
    validateQtyRules() {
      const value = parseInt(this.input.value);
      if (this.input.min) {
        const min = parseInt(this.input.min);
        this.subtract.classList.toggle('disabled', value <= min);
      }
      if (this.input.max) {
        const max = parseInt(this.input.max);
        this.add.classList.toggle('disabled', value >= max);
      }
    }
  }
  customElements.define('quantity-selector', QuantityInput);
}

/**
 *  @class
 *  @function ProductCard
 */
if (!customElements.get('product-card')) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.swatches = this.querySelector('.product-card-swatches');
      this.secondary = this.querySelector('.product-secondary-image');
      this.image = this.secondary || this.querySelector('.product-primary-image');
      this.quick_add = this.querySelector('.product-card--add-to-cart-button-simple');
      this.size_options = this.querySelector('.product-card-sizes');
    }
    connectedCallback() {
      if (this.swatches) {
        this.enableSwatches(this.swatches, this.image);
      }
      if (this.quick_add) {
        this.enableQuickAdd();
      }
      if (this.secondary) {
        window.addEventListener('load', (event) => {
          lazySizes.loader.unveil(this.secondary);
        });
      }
      if (this.size_options) {
        this.enableSizeOptions();
      }

    }
    enableSwatches(swatches, image) {
      let swatch_list = swatches.querySelectorAll('.product-card-swatch'),
        org_srcset = image ? image.dataset.srcset : '';
      this.color_index = this.swatches.dataset.index;

      swatch_list.forEach((swatch, index) => {
        window.addEventListener('load', (event) => {
          let image = new Image();
          image.srcset = swatch.dataset.srcset;
          lazySizes.loader.unveil(image);
        });
        const previewSwatch = () => {

          [].forEach.call(swatch_list, function (el) {
            el.classList.remove('active');
          });
          if (image) {
            if (swatch.dataset.srcset) {
              image.setAttribute('srcset', swatch.dataset.srcset);
            } else {
              image.setAttribute('srcset', org_srcset);
            }
          }
          if (this.size_options) {
            this.current_options[this.color_index] = swatch.querySelector('span').innerText;
            this.updateMasterId();
          }
          swatch.classList.add('active');
        };
        swatch.addEventListener('mouseover', previewSwatch);
        swatch.addEventListener('focus', previewSwatch);
      });
    }
    enableQuickAdd() {
      this.quick_add.addEventListener('click', this.quickAdd.bind(this));
    }
    enableSizeOptions() {
      let size_list = this.size_options.querySelectorAll('.product-card-sizes--size'),
        featured_image = this.querySelector('.product-featured-image'),
        has_hover = featured_image.classList.contains('thb-hover'),
        size_parent = this.size_options.parentElement;

      this.size_index = this.size_options.dataset.index;

      this.current_options = this.size_options.dataset.options.split(',');

      this.updateMasterId();

      size_parent.addEventListener('mouseenter', () => {
        if (has_hover) {
          featured_image.classList.remove('thb-hover');
        }
      }, {
        passive: true
      });
      size_parent.addEventListener('mouseleave', () => {
        if (has_hover) {
          featured_image.classList.add('thb-hover');
        }
      }, {
        passive: true
      });
      size_list.forEach((size) => {
        size.addEventListener('click', (evt) => {
          evt.preventDefault();

          if (size.classList.contains('is-disabled')) {
            return;
          }
          this.current_options[this.size_index] = size.querySelector('span').innerText;
          this.updateMasterId();

          size.classList.add('loading');
          size.setAttribute('aria-disabled', true);
          const config = {
            method: 'POST',
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
              'Accept': 'application/javascript'
            }
          };
          let formData = new FormData();

          formData.append('id', this.currentVariant.id);
          formData.append('quantity', 1);
          formData.append('sections', this.getSectionsToRender().map((section) => section.section));
          formData.append('sections_url', window.location.pathname);

          config.body = formData;

          fetch(`${theme.routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                return;
              }
              this.renderContents(response);

              dispatchCustomEvent('cart:item-added', {
                product: response.hasOwnProperty('items') ? response.items[0] : response
              });
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              size.classList.remove('loading');
              size.removeAttribute('aria-disabled');
            });
        });
      });
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.current_options[index] === option;
        }).includes(false);
      });
      setTimeout(() => {
        this.setDisabled();
      }, 100);
    }
    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
    setDisabled() {
      const variant_data = this.getVariantData();

      if (variant_data) {

        if (this.currentVariant) {
          const selected_options = this.currentVariant.options.map((value, index) => {
            return {
              value,
              index: `option${index + 1}`
            };
          });

          const available_options = this.createAvailableOptionsTree(variant_data, selected_options);

          const fieldset_options = Object.values(available_options)[this.size_index];
          if (fieldset_options) {
            if (this.size_options.querySelectorAll('.product-card-sizes--size').length) {
              this.size_options.querySelectorAll('.product-card-sizes--size').forEach((input, input_i) => {
                input.classList.toggle('is-disabled', fieldset_options[input_i].isUnavailable);
              });
            }
          }
        } else {
          if (this.size_options.querySelectorAll('.product-card-sizes--size').length) {
            this.size_options.querySelectorAll('.product-card-sizes--size').forEach((input, input_i) => {
              input.classList.add('is-disabled');
            });
          }
        }

      }
      return true;
    }
    createAvailableOptionsTree(variant_data, selected_options) {
      // Reduce variant array into option availability tree
      return variant_data.reduce((options, variant) => {

        // Check each option group (e.g. option1, option2, option3) of the variant
        Object.keys(options).forEach(index => {

          if (variant[index] === null) return;

          let entry = options[index].find(option => option.value === variant[index]);

          if (typeof entry === 'undefined') {
            // If option has yet to be added to the options tree, add it
            entry = {
              value: variant[index],
              isUnavailable: true
            };
            options[index].push(entry);
          }

          // Check how many selected option values match a variant
          const countVariantOptionsThatMatchCurrent = selected_options.reduce((count, {
            value,
            index
          }) => {
            return variant[index] === value ? count + 1 : count;
          }, 0);

          // Only enable an option if an available variant matches all but one current selected value
          if (countVariantOptionsThatMatchCurrent >= selected_options.length - 1) {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }

          // Make sure if a variant is unavailable, disable currently selected option
          if ((!this.currentVariant || !this.currentVariant.available) && selected_options.find((option) => option.value === entry.value && index === option.index)) {
            entry.isUnavailable = true;
          }

          // First option is always enabled
          if (index === 'option1') {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }
        });

        return options;
      }, {
        option1: [],
        option2: [],
        option3: []
      });
    }
    quickAdd(evt) {
      evt.preventDefault();
      if (this.quick_add.getAttribute('disabled') != undefined) {
        return;
      }
      this.quick_add.classList.add('loading');
      this.quick_add.setAttribute('aria-disabled', true);

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };

      let formData = new FormData();

      formData.append('id', this.quick_add.dataset.productId);
      formData.append('quantity', 1);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return;
          }
          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.quick_add.classList.remove('loading');
          this.quick_add.removeAttribute('aria-disabled');
        });

      return false;
    }
    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));


      if (document.getElementById('Cart-Drawer')) {
        document.getElementById('Cart-Drawer').classList.add('active');
        document.body.classList.add('open-cart');
        document.body.classList.add('open-cc');
        if (document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full')) {
          document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full').classList.add('active');
        }
        dispatchCustomEvent('cart-drawer:open');
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
  }
  customElements.define('product-card', ProductCard);
}



/**
 *  @class
 *  @function PanelClose
 */
if (!customElements.get('side-panel-close')) {
  class PanelClose extends HTMLElement {

    constructor() {
      super();
      let cc = document.querySelector('.click-capture');
      // Add functionality to buttons
      this.panel = this.closest('.side-panel');
      this.addEventListener('click', (e) => this.close_panel(e));
      this.addEventListener('keydown', (e) => this.close_panel(e));
      cc.addEventListener('click', (e) => this.close_panel(e));
      document.addEventListener('panel:close', (e) => {
        let panel = document.querySelectorAll('.side-panel.active, .open-search .search-drawer');

        if (panel.length) {
          this.close_panel(e, panel[0]);
        }
      });
    }

    close_panel(e, side_panel) {
      let panel = this.panel;
      if (e.type === 'keydown' && !['Enter', ' '].includes(e.key)) {
        return;
      }
      if (e.type === 'keydown') e.preventDefault();
      if (side_panel) {
        panel = side_panel;
      }
      if (!panel) {
        panel = document.querySelector('.side-panel.active');
      }
      if (panel) {
        panel.classList.remove('active');
      }
      if (document.body.classList.contains('open-cc--product')) {
        document.body.classList.remove('open-cc--product');
        setTimeout(() => {
          document.querySelector('#Product-Drawer-Content').innerHTML = '';
        }, 260);
      } else if (panel?.classList.contains('cart-drawer') && document.querySelector('.view-products-panel.active')) {
        return;
      } else {
        if (document.body.classList.contains('open-search')) {
          document.body.classList.remove('open-search');
          dispatchCustomEvent('search:close');
        }
        document.body.classList.remove('open-cc');
      }

      if (document.body.classList.contains('overflow-hidden')) {
        document.body.classList.remove('overflow-hidden');
      }
    }
  }
  customElements.define('side-panel-close', PanelClose);

  document.addEventListener('keydown', (event) => {
    const panel = event.target.closest('.side-panel.active, .open-search .search-drawer');
    if (event.key !== 'Escape' || event.defaultPrevented || event.repeat || event.isComposing || event.keyCode === 229 ||
      !document.hasFocus() || !panel?.contains(document.activeElement) || event.target.closest('modal-dialog[open]')) return;
    event.preventDefault();
    dispatchCustomEvent('panel:close');
  });
}
/**
 *  @class
 *  @function CartDrawer
 */
class CartDrawer extends HTMLElement {

  constructor() {
    super();
  }

  connectedCallback() {
    this.setupAccessibility();
    this.button = document.getElementById('cart-drawer-toggle');
    // Keep the cart URL as a no-JavaScript fallback; enhance to a dialog trigger.
    this.button?.setAttribute('role', 'button');
    this.button?.setAttribute('aria-haspopup', 'dialog');
    this.button?.setAttribute('aria-controls', this.id);
    this.button?.addEventListener('keydown', (event) => {
      if (event.code === 'Space' && this.button.tagName === 'A') {
        event.preventDefault();
        if (!event.repeat) this.button.click();
      }
    }, { signal: this.a11yEvents.signal });

    // Add functionality to buttons
    this.button?.addEventListener('click', (e) => {
      e.preventDefault();
      document.body.classList.add('open-cc');
      document.body.classList.add('open-cart');
      this.classList.add('active');
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
      });
      dispatchCustomEvent('cart-drawer:open');
    });

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    document.addEventListener('cart:refresh', (event) => {
      this.refresh();
    });

    this.addEventListener('change', this.debouncedOnChange.bind(this));

    this.notesToggle();
    this.removeProductEvent();
    this.updateFreeShipping();
  }
  // Observe the shared active state so product forms, cards and quick views
  // all receive the same focus handling, including asynchronous section renders.
  setupAccessibility() {
    this.a11yObserver?.disconnect();
    this.a11yEvents?.abort();
    this.a11yEvents = new AbortController();
    const options = { capture: true, signal: this.a11yEvents.signal };
    this.backgroundElements = [];
    this.isModalOpen = false;
    this.inert = !this.classList.contains('active');

    document.addEventListener('click', (event) => {
      if (!this.isModalOpen && !this.contains(event.target)) {
        this.returnFocus = event.target.closest('button, a[href], input, [tabindex]') || document.activeElement;
      }
    }, options);
    document.addEventListener('focusin', (event) => {
      if (!this.isModalOpen) {
        if (!this.contains(event.target)) this.returnFocus = event.target;
        return;
      }
      if (!this.contains(event.target)) {
        this.focusHeading();
        return;
      }
      const row = event.target.closest('[data-cart-item-key]');
      this.focusSnapshot = {
        element: event.target,
        id: event.target.id,
        key: row?.dataset.cartItemKey,
        rowIndex: row ? Array.from(this.querySelectorAll('[data-cart-item-key]')).indexOf(row) : -1,
        controlIndex: row ? this.focusableElements(row).indexOf(event.target) : -1
      };
    }, options);
    document.addEventListener('keydown', (event) => {
      if (!this.isModalOpen) return;
      if (event.key === 'Escape') {
        if (event.defaultPrevented || event.repeat || event.isComposing || event.keyCode === 229 ||
          !document.hasFocus() || !this.contains(event.target) || !this.contains(document.activeElement)) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.querySelector('side-panel-close')?.click();
      } else if (event.key === 'Tab') {
        const elements = this.focusableElements();
        const first = elements[0];
        const last = elements[elements.length - 1];
        const current = document.activeElement;
        if (!first) {
          event.preventDefault();
          this.focusHeading();
        } else if (event.shiftKey && (current === first || !elements.includes(current))) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && (current === last || !elements.includes(current))) {
          event.preventDefault();
          first.focus();
        }
      }
    }, options);

    this.a11yObserver = new MutationObserver(() => this.syncAccessibility());
    this.a11yObserver.observe(this, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
    this.syncAccessibility();
  }
  focusableElements(root = this) {
    return Array.from(root.querySelectorAll('a[href], button, input, select, textarea, [tabindex]'))
      .filter((element) => element.tabIndex >= 0 && this.canFocus(element));
  }
  canFocus(element) {
    return element?.isConnected && !element.matches(':disabled') &&
      !element.closest('[inert], [hidden], [aria-hidden="true"], .side-panel:not(.active)') &&
      element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden';
  }
  focusHeading() {
    (this.querySelector('#CartDrawerTitle') || this).focus({ preventScroll: true });
  }
  isolateBackground() {
    // Walk out through section/wrapper ancestors; never inert the drawer itself.
    for (let branch = this; branch.parentElement; branch = branch.parentElement) {
      for (const sibling of branch.parentElement.children) {
        if (sibling === branch || sibling.inert || sibling.matches('script, style, link, .click-capture')) continue;
        sibling.inert = true;
        this.backgroundElements.push(sibling);
      }
      if (branch.parentElement === document.body) break;
    }
  }
  releaseBackground() {
    this.backgroundElements?.forEach((element) => { element.inert = false; });
    this.backgroundElements = [];
  }
  syncAccessibility() {
    const open = this.classList.contains('active');
    if (open !== this.isModalOpen) {
      this.isModalOpen = open;
      this.inert = !open;
      if (open) {
        if (!this.returnFocus && !this.contains(document.activeElement)) this.returnFocus = document.activeElement;
        this.focusHeading();
        this.isolateBackground();
      } else {
        this.releaseBackground();
        document.body.classList.remove('open-cart');
        const target = this.canFocus(this.returnFocus) ? this.returnFocus : document.getElementById('cart-drawer-toggle');
        if (this.canFocus(target)) target.focus({ preventScroll: true });
        this.focusSnapshot = null;
      }
    } else if (open && !this.contains(document.activeElement)) {
      // Section replacement removes the focused node. Match the stable line-item
      // key rather than its line number, which changes when an item is removed.
      const snapshot = this.focusSnapshot;
      const rows = Array.from(this.querySelectorAll('[data-cart-item-key]'));
      const row = rows.find((element) => element.dataset.cartItemKey === snapshot?.key);
      let target = row && this.focusableElements(row)[snapshot.controlIndex];
      if (!target && snapshot?.key) {
        const nextRow = rows[Math.min(snapshot.rowIndex, rows.length - 1)];
        target = nextRow?.querySelector('.cart-product-link');
      } else if (!target && snapshot?.id) {
        target = Array.from(this.querySelectorAll('[id]')).find((element) => element.id === snapshot.id);
      }
      if (this.canFocus(target)) target.focus({ preventScroll: true });
      else this.focusHeading();
    }
  }
  disconnectedCallback() {
    this.a11yObserver?.disconnect();
    this.a11yEvents?.abort();
    this.releaseBackground();
  }
  onChange(event) {
    if (event.target.classList.contains('qty')) {
      this.updateQuantity(event.target.dataset.index, event.target.value);
    }
  }
  removeProductEvent() {
    let removes = this.querySelectorAll('.remove');

    removes.forEach((remove) => {
      remove.addEventListener('click', (event) => {
        this.updateQuantity(event.target.dataset.index, '0');

        event.preventDefault();
      });
    });
  }
  getSectionsToRender() {
    return [{
      id: 'Cart-Drawer',
      section: 'cart-drawer',
      selector: '.cart-drawer-inner'
    },
    {
      id: 'cart-drawer-toggle',
      section: 'cart-bubble',
      selector: '.thb-item-count'
    }];
  }
  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
  termsCheckbox() {
    let terms_checkbox = this.querySelector('#CartDrawerTerms'),
      checkout_button = this.querySelector('.button.checkout');

    if (terms_checkbox && checkout_button) {
      terms_checkbox.setCustomValidity(theme.strings.requiresTerms);
      checkout_button.addEventListener('click', function (e) {
        if (!terms_checkbox.checked) {
          terms_checkbox.reportValidity();
          terms_checkbox.focus();
          e.preventDefault();
        }
      });
    }
  }
  notesToggle() {
    let notes_toggle = this.querySelector('#order-note-toggle');

    if (!notes_toggle) {
      return;
    }

    notes_toggle.addEventListener('click', (event) => {
      notes_toggle.nextElementSibling.classList.add('active');
    });
    notes_toggle.nextElementSibling.querySelectorAll('.button, .order-note-toggle__content-overlay').forEach((el) => {
      el.addEventListener('click', (event) => {
        notes_toggle.nextElementSibling.classList.remove('active');
        this.saveNotes();
      });
    });
  }
  saveNotes() {
    fetch(`${theme.routes.cart_update_url}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': `application/json`
      },
      body: JSON.stringify({
        'note': document.getElementById('mini-cart__notes').value
      })
    });
  }
  updateFreeShipping() {
    const free_shipping = this.querySelector('.free-shipping');

    if (free_shipping) {
      let amount_text = free_shipping.querySelector('.free-shipping--text span');
      let total = parseInt(free_shipping.dataset.cartTotal, 10);
      let minimum = Math.round(parseInt(free_shipping.dataset.minimum, 10) * (Shopify.currency.rate || 1));
      let percentage = 1;

      if (total < minimum) {
        percentage = total / minimum;

        if (amount_text) {
          let remaining = minimum - total,
            format = window.theme.settings.money_with_currency_format || "${{amount}}";
          amount_text.innerHTML = formatMoney(remaining, format);
        }
      }

      free_shipping.style.setProperty('--percentage', percentage);
    }
  }
  updateQuantity(line, quantity) {
    this.querySelector(`#CartDrawerItem-${line}`)?.classList.add('thb-loading');
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    dispatchCustomEvent('line-item:change:start', {
      quantity: quantity
    });

    fetch(`${theme.routes.cart_change_url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': `application/json`
      },
      ...{
        body
      }
    })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          if (parsedState.sections) {
            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          }
        }));

        this.removeProductEvent();
        this.notesToggle();
        this.updateFreeShipping();
        dispatchCustomEvent('line-item:change:end', {
          quantity: quantity,
          cart: parsedState
        });

        if (this.querySelector(`#CartDrawerItem-${line}`)) {
          this.querySelector(`#CartDrawerItem-${line}`).classList.remove('thb-loading');
        }
      });
  }
  refresh() {
    let sections = 'cart-drawer,cart-bubble';
    fetch(`${window.location.pathname}?sections=${sections}`)
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState[section.section], section.selector);
        }));

        this.removeProductEvent();
        this.notesToggle();
        this.updateFreeShipping();
      });
  }
}
customElements.define('cart-drawer', CartDrawer);

/**
 *  @class
 *  @function ModalDialog
 */
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.closeButton = this.querySelector('[id^="ModalClose-"]');

    if (this.closeButton) {
      this.closeButton.addEventListener(
        'click',
        this.hide.bind(this)
      );
      this.closeButton.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() === 'ENTER') {
          this.hide();
        }
      });
    }

    this.addEventListener('compositionstart', () => { this.isComposing = true; });
    this.addEventListener('compositionend', () => { this.isComposing = false; });
    this.addEventListener('focusout', () => { this.isComposing = false; });
    // Only a fresh Escape pressed inside the focused, open modal may dismiss it.
    // Keyup can arrive after an IME candidate or another window consumed keydown.
    this.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || event.defaultPrevented || event.repeat || event.isComposing ||
        event.keyCode === 229 || this.isComposing || !this.hasAttribute('open') ||
        !document.hasFocus() || !this.contains(document.activeElement)) return;
      event.preventDefault();
      event.stopPropagation();
      this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    if (this.dataset.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  isMobileProductModal() {
    return window.matchMedia('(max-width: 1067px)').matches &&
      this.matches('.product-popup-modal, .product-add-to-cart-sticky-modal');
  }

  show(opener) {
    this.openedBy = opener || document.activeElement;
    this.openerId = this.openedBy?.id;
    this.isComposing = false;
    this.windowEvents?.abort();
    this.windowEvents = new AbortController();
    const windowOptions = { signal: this.windowEvents.signal };
    // An IME may omit compositionend when the user switches applications.
    // Do not let that stale state suppress a fresh Escape after returning.
    window.addEventListener('blur', () => { this.isComposing = false; }, windowOptions);
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) this.isComposing = false;
    }, windowOptions);
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');

    this.mobileProductIsolation = this.isMobileProductModal();
    if (this.mobileProductIsolation || this.classList.contains('facets-popup-modal') || this.id === 'LocalizationModal--locale') {
      this.activateFacetModal();
      return;
    }

    clearTimeout(this.focusTimer);
    this.focusTimer = setTimeout(() => {
      if (this.hasAttribute('open') && document.hasFocus()) this.querySelector('[role="dialog"]')?.focus();
    }, 100);
  }

  hide() {
    if (!this.hasAttribute('open')) return;
    this.windowEvents?.abort();
    clearTimeout(this.focusTimer);
    this.isComposing = false;
    if (this.mobileProductIsolation || this.classList.contains('facets-popup-modal') || this.id === 'LocalizationModal--locale') {
      this.releaseFacetModal();
      this.mobileProductIsolation = false;
    }
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    const opener = this.openedBy?.isConnected ? this.openedBy : document.getElementById(this.openerId);
    opener?.focus();
    this.querySelectorAll('.js-youtube').forEach((video) => {
      video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });
    this.querySelectorAll('.js-vimeo').forEach((video) => {
      video.contentWindow.postMessage('{"method":"pause"}', '*');
    });
    this.querySelectorAll('video').forEach((video) => video.pause());
  }

  activateFacetModal() {
    this.releaseFacetModal();
    this.openerId = this.openedBy?.id;
    const dialog = this.querySelector('[role="dialog"]');
    const canFocus = el => el && el.isConnected && !el.closest('[inert]') &&
      !el.disabled && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden';
    const focusables = () => Array.from(dialog.querySelectorAll('a[href], button, input, select, textarea, [tabindex]'))
      .filter(el => el.tabIndex >= 0 && canFocus(el));
    this.facetEvents = new AbortController();
    const options = { capture: true, signal: this.facetEvents.signal };
    document.addEventListener('keydown', event => {
      if (event.key === 'Tab') {
        const items = focusables();
        const first = items[0], last = items[items.length - 1];
        if (!first || !dialog.contains(document.activeElement) || document.activeElement === dialog ||
          (event.shiftKey ? document.activeElement === first : document.activeElement === last)) {
          event.preventDefault();
          (event.shiftKey ? last || dialog : first || dialog).focus();
        }
      }
    }, options);
    document.addEventListener('focusin', event => {
      if (!dialog.contains(event.target)) dialog.focus({ preventScroll: true });
      else this.facetFocusedId = event.target.id;
    }, options);
    dialog.focus({ preventScroll: true });
    // The filter modal stays inside its form. Isolate siblings at every level,
    // never an ancestor containing the modal or pre-existing inert content.
    this.facetBackground = [];
    for (let branch = this; branch.parentElement; branch = branch.parentElement) {
      for (const sibling of branch.parentElement.children) {
        if (sibling === branch || sibling.inert || sibling.matches('script, style, link')) continue;
        this.facetBackground.push({ element: sibling, ariaHidden: sibling.getAttribute('aria-hidden') });
        sibling.inert = true;
        sibling.setAttribute('aria-hidden', 'true');
      }
      if (branch.parentElement === document.body) break;
    }
    this.facetObserver = new MutationObserver(() => {
      if (!dialog.contains(document.activeElement)) {
        const replacement = document.getElementById(this.facetFocusedId);
        (dialog.contains(replacement) && canFocus(replacement) ? replacement : dialog).focus({ preventScroll: true });
      }
    });
    this.facetObserver.observe(dialog, { childList: true, subtree: true });
  }

  releaseFacetModal() {
    this.facetEvents?.abort();
    this.facetObserver?.disconnect();
    this.facetBackground?.forEach(({ element, ariaHidden }) => {
      element.inert = false;
      if (ariaHidden === null) element.removeAttribute('aria-hidden');
      else element.setAttribute('aria-hidden', ariaHidden);
    });
    this.facetBackground = [];
  }

  disconnectedCallback() {
    clearTimeout(this.focusTimer);
    this.windowEvents?.abort();
    this.isComposing = false;
    this.releaseFacetModal();
    if ((this.mobileProductIsolation || this.classList.contains('facets-popup-modal') || this.id === 'LocalizationModal--locale') && this.hasAttribute('open')) {
      document.body.classList.remove('overflow-hidden');
    }
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

/**
 *  @class
 *  @function SelectWidth
 */
class SelectWidth {
  constructor() {
    let _this = this;
    // resize on initial load
    window.addEventListener('load', () => {
      document.querySelectorAll('.resize-select').forEach(_this.resizeSelect);
    });

    // delegated listener on change
    document.body.addEventListener('change', (e) => {
      if (e.target.matches('.resize-select') && e.target.offsetParent !== null) {
        _this.resizeSelect(e.target);
      }
    });
    window.addEventListener('resize.resize-select', function () {
      document.querySelectorAll('.resize-select').forEach(_this.resizeSelect);
    });
  }

  resizeSelect(sel) {
    let tempOption = document.createElement('option');
    tempOption.textContent = sel.selectedOptions[0].textContent;

    let tempSelect = document.createElement('select'),
      offset = 13;
    tempSelect.style.visibility = 'hidden';
    tempSelect.style.position = 'fixed';
    tempSelect.appendChild(tempOption);
    if (sel.classList.contains('thb-language-code') || sel.classList.contains('thb-currency-code') || sel.classList.contains('facet-filters__sort')) {
      offset = 2;
    }
    sel.after(tempSelect);
    if (tempSelect.clientWidth > 0) {
      sel.style.width = `${+tempSelect.clientWidth + offset}px`;
    }
    tempSelect.remove();
  }
}

if (typeof SelectWidth !== 'undefined') {
  new SelectWidth();
}

/**
 *  @class
 *  @function QuickView
 */
if (!customElements.get('quick-view')) {
  class QuickView extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.cc = document.querySelector('.click-capture--product');
      this.drawer = document.getElementById('Product-Drawer');
      this.body = document.body;

      this.addEventListener('click', this.setupEventListener.bind(this));

      if (this.cc) {
        this.cc.addEventListener('click', this.setupCCEventListener.bind(this));
      }
    }

    setupCCEventListener(e) {
      if (!this.drawer) return;

      this.body.classList.remove('open-cc--product');
      this.drawer.classList.remove('active');

      setTimeout(() => {
        const content = this.drawer.querySelector('#Product-Drawer-Content');
        if (content) {
          content.innerHTML = '';
        }
      }, 260);
    }

    loadProductScript() {
      if (customElements.get('product-form')) {
        return Promise.resolve();
      }

      if (window.productScriptPromise) {
        return window.productScriptPromise;
      }

      window.productScriptPromise = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = window.theme.assets.product_script;
        script.onload = resolve;
        script.onerror = () => reject(new Error('Product script failed to load'));
        document.head.appendChild(script);
      });

      return window.productScriptPromise;
    }

    setupEventListener(e) {
      e.preventDefault();
      e.stopPropagation();

      if (this.hasAttribute('disabled') || this.disabled) {
        return;
      }

      // 有 data-product-id：直接加购，不走弹窗
      if (this.dataset.productId) {
        this.directAddToCart();
        return;
      }

      // 没有 data-product-id：继续原 quick view 逻辑
      let productHandle = this.dataset.productHandle;
      let href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`;

      if (!productHandle) {
        return;
      }

      href = href.replace('//', '/');

      if (this.classList.contains('loading')) {
        return;
      }

      this.classList.add('loading');

      Promise.all([
        fetch(href, {
          method: 'GET'
        }),
        this.loadProductScript()
      ])
        .then(([response]) => {
          this.classList.remove('loading');
          return response.text();
        })
        .then((text) => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const container = doc.querySelector('#Product-Drawer-Content');

          if (!container) return;

          this.renderQuickview(container.innerHTML, href, productHandle);
        })
        .catch((err) => {
          console.error(err);
          this.classList.remove('loading');
        });
    }

    directAddToCart() {
      if (this.classList.contains('loading')) {
        return;
      }

      const variantId = this.dataset.productId;
      if (!variantId) {
        return;
      }

      this.classList.add('loading');
      this.setAttribute('aria-disabled', 'true');

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };

      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', 1);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            console.error('Add to cart failed:', response.description || response.message);
            return;
          }

          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.classList.remove('loading');
          this.removeAttribute('aria-disabled');
        });
    }

    getSectionsToRender() {
      return [
        {
          id: 'Cart',
          section: 'main-cart',
          selector: '.thb-cart-form'
        },
        {
          id: 'Cart-Drawer',
          section: 'cart-drawer',
          selector: '.cart-drawer'
        },
        {
          id: 'cart-drawer-toggle',
          section: 'cart-bubble',
          selector: '.thb-item-count'
        }
      ];
    }

    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section) => {
        const sectionElement = document.getElementById(section.id);
        if (!sectionElement || !parsedState.sections || !parsedState.sections[section.section]) {
          return;
        }

        const elementToReplace =
          sectionElement.querySelector(section.selector) || sectionElement;

        const html = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        if (html) {
          elementToReplace.innerHTML = html;
        }

        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      });

      const cartDrawer = document.getElementById('Cart-Drawer');
      if (cartDrawer) {
        cartDrawer.classList.add('active');
        document.body.classList.add('open-cart');
        document.body.classList.add('open-cc');

        const recommendations = cartDrawer.querySelector('.product-recommendations--full');
        if (recommendations) {
          recommendations.classList.add('active');
        }

        dispatchCustomEvent('cart-drawer:open');
      }
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const target = doc.querySelector(selector);
      return target ? target.innerHTML : '';
    }

    renderQuickview(sectionInnerHTML, href, productHandle) {
      if (!sectionInnerHTML || !this.drawer) return;

      const content = this.drawer.querySelector('#Product-Drawer-Content');
      if (!content) return;

      content.innerHTML = sectionInnerHTML;

      let js_files = content.querySelectorAll('script');

      if (js_files.length > 0) {
        const head = document.getElementsByTagName('head')[0];
        js_files.forEach((js_file) => {
          let script = document.createElement('script');
          script.src = js_file.src;
          head.appendChild(script);
        });
      }

      setTimeout(() => {
        if (Shopify && Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }
        if (window.ProductModel) {
          window.ProductModel.loadShopifyXR();
        }
      }, 300);

      this.body.classList.add('open-cc--product');
      this.drawer.classList.add('active');

      const closeBtn = this.drawer.querySelector('.side-panel-close');
      if (closeBtn) {
        closeBtn.focus();
      }

      dispatchCustomEvent('quick-view:open', {
        productUrl: href,
        productHandle: productHandle
      });

      addIdToRecentlyViewed(productHandle);
    }
  }

  customElements.define('quick-view', QuickView);
}

/**
 *  @class
 *  @function CollapsibleRow
 */
if (!customElements.get('collapsible-row')) {
  // https://css-tricks.com/how-to-animate-the-details-element/
  class CollapsibleRow extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.content = this.querySelector('.collapsible__content');

      // Store the animation object (so we can cancel it if needed)
      this.animation = null;
      // Store if the element is closing
      this.isClosing = false;
      // Store if the element is expanding
      this.isExpanding = false;
    }
    connectedCallback() {
      this.setListeners();
      if (this.classList.contains('product__accordion')) {
        this.summary.setAttribute('role', 'button');
        if (this.content.id) this.summary.setAttribute('aria-controls', this.content.id);
        this.stateObserver = new MutationObserver(() => this.syncExpandedState());
        this.stateObserver.observe(this.details, { attributes: true, attributeFilter: ['open'] });
        this.syncExpandedState();
      }
    }
    syncExpandedState() {
      if (!this.classList.contains('product__accordion')) return;
      const expanded = this.details.open && !this.isClosing;
      this.summary.setAttribute('aria-expanded', String(expanded));
      this.content.inert = !expanded;
    }
    disconnectedCallback() {
      this.stateObserver?.disconnect();
    }
    setListeners() {
      this.querySelector('summary').addEventListener('click', (e) => this.onClick(e));
    }
    instantClose() {
      this.tl.timeScale(10).reverse();
    }
    animateClose() {
      this.tl.timeScale(3).reverse();
    }
    animateOpen() {
      this.tl.timeScale(1).play();
    }
    onClick(e) {
      // Stop default behaviour from the browser
      e.preventDefault();
      // Add an overflow on the <details> to avoid content overflowing
      this.details.style.overflow = 'hidden';
      // Check if the element is being closed or is already closed
      if (this.isClosing || !this.details.open) {
        this.open();
        // Check if the element is being openned or is already open
      } else if (this.isExpanding || this.details.open) {
        this.shrink();
      }
    }
    shrink() {
      // Set the element as "being closed"
      this.isClosing = true;
      this.syncExpandedState();

      // Store the current height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the height of the summary
      const endHeight = `${this.summary.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 250,
        easing: 'ease'
      });

      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(false);
      // If the animation is cancelled, isClosing variable is set to false
      this.animation.oncancel = () => this.isClosing = false;
    }

    open() {
      // Apply a fixed height on the element
      this.details.style.height = `${this.details.offsetHeight}px`;
      // Force the [open] attribute on the details element
      this.isClosing = false;
      this.details.open = true;
      this.syncExpandedState();
      // Wait for the next frame to call the expand function
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      // Set the element as "being expanding"
      this.isExpanding = true;
      // Get the current fixed height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the open height of the element (summary height + content height)
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });
      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(true);
      // If the animation is cancelled, isExpanding variable is set to false
      this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
      // Set the open attribute based on the parameter
      this.details.open = open;
      // Clear the stored animation
      this.animation = null;
      // Reset isClosing & isExpanding
      this.isClosing = false;
      this.isExpanding = false;
      // Remove the overflow hidden and the fixed height
      this.details.style.height = this.details.style.overflow = '';
      this.syncExpandedState();
    }
  }
  customElements.define('collapsible-row', CollapsibleRow);
}

/**
 *  @function addIdToRecentlyViewed
 */
function addIdToRecentlyViewed(handle) {

  if (!handle) {
    let product = document.querySelector('.thb-product-detail');

    if (product) {
      handle = product.dataset.handle;
    }
  }
  if (!handle) {
    return;
  }
  if (window.localStorage) {
    let recentIds = window.localStorage.getItem('recently-viewed');
    if (recentIds && typeof (recentIds) !== undefined) {
      window.recentlyViewedIds = JSON.parse(recentIds);
    }
  }
  // Remove current product if already in recently viewed array
  var i = window.recentlyViewedIds.indexOf(handle);

  if (i > -1) {
    window.recentlyViewedIds.splice(i, 1);
  }

  // Add id to array
  window.recentlyViewedIds.unshift(handle);

  if (window.localStorage) {
    window.localStorage.setItem('recently-viewed', JSON.stringify(window.recentlyViewedIds));
  }
}

/**
 *  Animations
 */
ScrollTrigger.batch('.animations-true .products .gallery--item figure, .animations-true .product-card .product-featured-image-link', {
  start: "top 90%",
  onEnter: (elements, triggers) => {
    gsap.to(elements, { scale: 1, opacity: 1, stagger: 0.15, ease: window.theme.settings.animation_easing });
  }
});
ScrollTrigger.batch('.animations-true .multicolumn--column-inner', {
  start: "top 90%",
  onEnter: (elements, triggers) => {
    gsap.to(elements, { y: 1, opacity: 1, stagger: 0.15, ease: window.theme.settings.animation_easing });
  }
});
ScrollTrigger.batch('.animations-true .blog-post .featured-image--link', {
  start: "top 90%",
  onEnter: (elements, triggers) => {
    gsap.to(elements, { scale: 1, opacity: 1, stagger: 0.15, ease: window.theme.settings.animation_easing });
  }
});

/**
 *  @class
 *  @function FooterMenuToggle
 */
class FooterMenuToggle {
  constructor() {
    const mobile = window.matchMedia('(max-width: 767px)');
    document.querySelectorAll('.thb-widget-title.collapsible').forEach((button, index) => {
      const panel = button.nextElementSibling;
      const isMenu = panel?.classList.contains('thb-widget-menu');
      if (isMenu) {
        if (!panel.id) panel.id = `FooterMenuPanel-${index}`;
        button.setAttribute('aria-controls', panel.id);
        button.type = 'button';
        button.querySelectorAll('span').forEach(icon => icon.setAttribute('aria-hidden', 'true'));
      }
      const sync = () => {
        if (!isMenu) return;
        const expanded = !mobile.matches || button.classList.contains('active');
        button.setAttribute('aria-expanded', String(expanded));
        panel.inert = !expanded;
      };
      button.addEventListener('click', () => {
        button.classList.toggle('active');
        sync();
      });
      mobile.addEventListener('change', sync);
      sync();
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (typeof FooterMenuToggle !== 'undefined') {
    new FooterMenuToggle();
  }
});
